export const CHANGE_USER_AVATAR_REQUEST = 'CHANGE_USER_AVATAR_REQUEST';
export const CHANGE_USER_AVATAR_SUCCESS = 'CHANGE_USER_AVATAR_SUCCESS';
export const CHANGE_USER_AVATAR_FAILURE = 'CHANGE_USER_AVATAR_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/change_user_avatar.constants.js